import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import logo from "../../images/logo.png";
import Footer from '../base/Footer';
import SignIn from './LoginPage';

const useStyles = makeStyles((theme) => ({
    page: {
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: 'radial-gradient(circle at 20% 20%, #0b3a7a 0%, #01295C 45%, #011c40 100%)',
    },
    body: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(4, 2),
    },
    inner: {
        width: '100%',
        maxWidth: 980,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(6),
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            gap: theme.spacing(4),
        },
    },
    brand: {
        flex: '1 1 0',
        textAlign: 'left',
        [theme.breakpoints.down('sm')]: {
            flex: 'none',
            textAlign: 'center',
        },
    },
    logo: {
        height: 128,
        maxWidth: '100%',
    },
    tagline: {
        marginTop: theme.spacing(2),
        fontWeight: 700,
    },
    caption: {
        marginTop: theme.spacing(1),
        color: 'rgba(255, 255, 255, 0.7)',
        maxWidth: 380,
        [theme.breakpoints.down('sm')]: {
            margin: `${theme.spacing(1)}px auto 0`,
        },
    },
    formArea: {
        flex: '1 1 0',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            flex: 'none',
            maxWidth: 440,
        },
    },
}));

export default function LoginContainer() {
    const classes = useStyles();
    return (
        <div className={classes.page}>
            <div className={classes.body}>
                <div className={classes.inner}>
                    <Box className={classes.brand}>
                        <img src={logo} className={classes.logo} alt="Team369" />
                        <Typography variant="h5" className={classes.tagline}>
                            Team369 Admin Panel
                        </Typography>
                        <Typography variant="body2" className={classes.caption}>
                            Members, plans, payouts and settings - all managed from one secure console.
                        </Typography>
                    </Box>
                    <div className={classes.formArea}>
                        <SignIn />
                    </div>
                </div>
            </div>
        </div>
    );
}
